import React, { useMemo, useState } from 'react'
import cn from 'classnames'
import Icon from '../Icon'
import st from './index.scss'

/**
 *
 * 选择器
 *
 * @param {object []} options 配置项 { label, value }[]
 * @param {string} placeholder 默认显示内容
 * @param {string} value 选中项的value值
 * @returns
 */
export default function Select({
    className,
    listClassName,
    options = [],
    value,
    placeholder = '请选择内容',
    onChange,
    ...props
}) {
    // 获取配置项的映射关系 value 重复的以最后一个为准
    const options_map = useMemo(() => {
        const obj = new Map()
        options.map((item) => obj.set(item.value, item))
        return obj
    }, [options])

    const selected_item = value ? options_map.get(value) : null
    const [fold, setFold] = useState(true) //是否折叠

    return (
        <div
            className={cn(st['box'], className)}
            {...props}
            onMouseEnter={() => setFold(false)}
            onMouseLeave={() => setFold(true)}
        >
            <div className={st['tripe']}>
                <div className={cn(st['tripe-text'],st[selected_item || 'no-tripe-text'])}>{selected_item ? selected_item.label : placeholder}</div>
                <Icon
                    className={st['icon']}
                    name={fold ? 'zhankaibeifen-copy' : 'zhankaibeifen'}
                />
            </div>

            <div className={st['listContent']}>
            {options.length > 0 && (
                <div className={cn(st['list'], listClassName)}>
                    {options.map((item, idx) => {
                        return (
                            <div
                                key={idx}
                                className={cn({
                                    [st['selected']]:
                                        selected_item &&
                                        selected_item.value === item.value
                                })}
                                onClick={() => onChange && onChange(item, idx)}
                            >
                                {item.label}
                            </div>
                        )
                    })}
                </div>
            )}
            </div>
        </div>
    )
}
